import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import PdpButton from "../../elements/pdp-button";
import { generateReactKey } from "../../utils/reactKey";
import classNames from "classnames";
import "./style.scss";

const PdpButtonGroup = ({ buttons, onSelected }) => {
  const [buttonList, setButtonList] = useState(buttons);
  useEffect(() => {
    let newButton = [];
    (buttons || []).map((item, i) => {
      newButton.push({ ...item });
    });
    setButtonList(newButton);
  }, [buttons]);
  const handleSelection = (event, id) => {
    event.preventDefault();

    const newItems = [...buttonList];
    newItems.map(item => {
      item.id === id ? (item.isSelected = true) : (item.isSelected = false);
    });
    setButtonList(newItems);
    if (onSelected) {
      onSelected(id);
    }
  };
  const handleButtons = () => {
    let buttonsArray = buttonList.map((button, index) => {
      if (buttonList.length < 4) {
        return <PdpButton {...{ ...button, handleSelection: handleSelection }} key={generateReactKey()} />;
      } else if (index === buttonList.length - 1 && index % 2 === 0) {
        return (
          <div className="last-column" key={generateReactKey()}>
            <PdpButton {...{ ...button, handleSelection: handleSelection }} />
          </div>
        );
      } else {
        return (
          <div className="column" key={generateReactKey()}>
            <PdpButton {...{ ...button, handleSelection: handleSelection }} />
          </div>
        );
      }
    });

    return buttonsArray;
  };

  return (
    <div
      className={classNames("main-container", {
        "single-item": buttonList && buttonList.length === 1
      })}
    >
      {buttonList != null && handleButtons()}
    </div>
  );
};

PdpButtonGroup.propTypes = {
  pdpButtons: PropTypes.arrayOf(PropTypes.object),
  onSelected: PropTypes.func
};

export default PdpButtonGroup;
